import React, { useEffect, useState } from "react";
import atoms from "../../atoms";
import molecules from "../../molecules";
import { InventoryAuditProps } from "./interface";
import { useDebounce } from "../../hook";

const { Input, Select, BarcodeSearch, Button } = atoms;
const { AuditProduct } = molecules;

const Index = ({
    handleBarcodeSearch,
    updateItemCondition,
    barcodeData,
    handleChange,
    updateData,
    inventoryItemCondition,
    searchTabContainer,
    skuOptions,
    errors,
}: InventoryAuditProps) => {


    return (
        <>
            <div className="row mt-3">
                <div className="col-md-6">
                    <div className="" ref={searchTabContainer}>
                        <div className=" position-relative">
                            <BarcodeSearch
                                searchCallBack={(val: string) => handleBarcodeSearch(val)}
                                placeholder="Enter Barcode Number"
                                className="fs-16"
                            />
                        </div>
                    </div>
                </div>
                <div className="col-md-6 d-none d-md-flex"></div>
            </div>
            {barcodeData ? (
                <>
                    <div className="my-3">
                        <AuditProduct barcodeData={barcodeData} />
                    </div>
                    <div>
                        <div className="row mt-md-4 mt-2">
                            <div className="col-md-4">
                                <label className={`inputs-label mb-2 fs-16 fw-600`}>
                                    Condition of the items
                                </label>
                                <Select
                                    options={inventoryItemCondition}
                                    name={"item_condition"}
                                    value={updateData?.item_condition}
                                    className={"w-100"}
                                    placeholder={"Select Condition"}
                                    onChange={(e: any) => {
                                        handleChange("item_condition", e);
                                    }}
                                    errors={!updateData?.item_condition && errors?.item_condition}
                                />
                            </div>
                            <div className="col-md-4">
                                <label className={`inputs-label mb-2 fs-16 fw-600`}>SKU</label>
                                <Select
                                    options={skuOptions}
                                    name={"item_condition"}
                                    value={updateData?.sku}
                                    className={"w-100"}
                                    placeholder={"Select SKU"}
                                    onChange={(e: any) => {
                                        handleChange("sku", e);
                                    }}
                                    errors={!updateData?.sku && errors?.sku}
                                />
                            </div>
                            <div className="col-md-4"></div>
                        </div>
                        <div className="mt-md-4 mt-2">
                            <div className="col-12">
                                <label className={`inputs-label mb-2 fs-16 fw-600`}>
                                    Product Condition Remark
                                </label>
                                <Input
                                    type={"text"}
                                    name={"conditionRemark"}
                                    value={updateData.conditionRemark}
                                    placeholder={"Enter Description Here"}
                                    onChange={(e: any) => {
                                        handleChange("conditionRemark", e.target.value);
                                    }}
                                    errors={
                                        !updateData?.conditionRemark && errors?.conditionRemark
                                    }
                                />
                            </div>
                        </div>
                    </div>
                    <div className="mx-1 mt-20">
                        <Button
                            name={"Save"}
                            className={"w-100"}
                            onClick={() => {
                                updateItemCondition(barcodeData?.id);
                            }}
                        />
                    </div>
                </>
            ) : (
                <div className="mt-3 d-flex justify-content-center mt-3 dark-gray">
                    <span>There are no records to display</span>
                </div>
            )}
        </>
    );
};

export default Index;
